module.exports = __webpack_public_path__ + "563bab5f87bdf04036ab31510e2baed1.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_3_0.ttf
// module id = 539
// module chunks = 0